import React from 'react';
import SEO from '../components/SEO';
import './Projects.css';

const Projects = () => {
  const projects = [
      {
        id: 1,
        title: 'GLOD',
        description: 'Piyasayı anlamanın en kolay yolu. Altın, döviz ve değerli metallerin güncel fiyatlarını gerçek zamanlı olarak takip edin. Karmaşık piyasa verilerini sade ve anlaşılır bir şekilde sunarak, kullanıcıların hızlıca bilgiye erişmesini ve daha bilinçli kararlar almasını sağlar. Gerçek zamanlı veriler, sade gösterim, anlaşılır analizler ve kullanıcı katılımına açık yaklaşım ile piyasayı herkes için erişilebilir hale getirir.',
        category: 'Web Uygulaması',
        technologies: ['React',"Node.js", 'Real-time Data', 'Multiple APIs Entegration', 'User-Friendly Interface'],
        image: '/assets/projects/glod.png',
        link: 'https://glod.lysep.com',
        github: null,
        featured: true,
        date: '2 Kasım 2025',
        themeColor: '#FFD700' // Altın rengi - GLOD için uygun
      },
    // Daha fazla proje buraya eklenecek
  ];

      return (
        <>
          <SEO
            title="Projelerimiz"
            description="LYSEP CORPORATION'un gerçekleştirdiği projeleri keşfedin. Web uygulamaları, yazılım çözümleri ve teknoloji projelerimizi inceleyin. GLOD ve diğer projelerimiz."
            keywords="LYSEP projeleri, web uygulamaları, yazılım projeleri, teknoloji çözümleri, GLOD, gerçekleştirilen projeler, portfolio"
            path="/projects"
          />
          <section className="projects-page">
            <div className="projects-hero">
        <div className="container">
          <h1 className="projects-title">Projelerimiz</h1>
          <p className="projects-subtitle">
            Gerçekleştirdiğimiz projeler ve çözümlerimizi keşfedin
          </p>
        </div>
      </div>

      <div className="container">
        <div className="projects-grid">
          {projects.map((project) => (
            <div 
              key={project.id} 
              className={`project-card ${project.featured ? 'featured' : ''}`}
              style={{
                '--project-color': project.themeColor || '#fd7000'
              }}
            >
              <div className="project-image">
                {project.image ? (
                  <img src={project.image} alt={project.title} />
                ) : (
                  <div className="project-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                      <line x1="8" y1="21" x2="16" y2="21"/>
                      <line x1="12" y1="17" x2="12" y2="21"/>
                    </svg>
                  </div>
                )}
                {project.featured && (
                  <div className="featured-badge">
                    <span>Öne Çıkan</span>
                  </div>
                )}
              </div>
              
              <div className="project-content">
                <div className="project-category">{project.category}</div>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                
                <div className="project-technologies">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
                
                <div className="project-actions">
                  {project.link && project.link !== '#' && (
                    <a href={project.link} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                      Projeyi Görüntüle
                    </a>
                  )}
                  {project.github && project.github !== '#' && project.github !== '' && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                      </svg>
                      GitHub
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="projects-empty" style={{ display: projects.length === 0 ? 'block' : 'none' }}>
          <p>Henüz proje eklenmemiş.</p>
        </div>
      </div>
    </section>
    </>
  );
};

export default Projects;

